<template>
  <div>
    <translated-entity-badge
      v-if="valueIsDefined"
      :value="params.value"
      :values="params.values"
      :invalid="params.invalid"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import TranslatedEntityBadge from '@/components/common/TranslatedEntityBadge'

export default Vue.extend({
    name: 'TranslatedEntityRenderer',
    components: {
        TranslatedEntityBadge
    },
    computed: {
        valueIsDefined() {
            return this.params.value !== undefined
        }
    }
})

</script>
